import { axiosWithToken } from '../utils/functions/apiCallWithToken';
import { SERVER_URL as serverURL } from '../core/config';



export const fetchCoupon = async (code) => {
    const result = await axiosWithToken(`${serverURL}/coupon/${code}/`, 'get', {});
    return result;
}

export const fetchCoupons = async () => {
    const result = await axiosWithToken(`${serverURL}/coupon/`, 'get', {});
    return result;
}

export const createCoupon = async (data) => {
    const result = await axiosWithToken(`${serverURL}/coupon/create/`, 'post', data);
    return result;
}

export const updateCoupon = async (id, data) => {
    const result = await axiosWithToken(`${serverURL}/coupon/update/${id}/`, 'put', data);
    return result;
}

export const setCouponActive = async (id, active) => {
    const result = await axiosWithToken(`${serverURL}/coupon/active/${id}/`, 'patch', { active });
    return result;
}

export const removeCoupon = async (id) => {
    const result = await axiosWithToken(`${serverURL}/coupon/remove/${id}`, 'delete', {});
    return result;
}

// SPEC-2026-06-29 reward-accounting : dû par bénéficiaire x méthode de paiement (admin, reporting).
export const fetchCouponRewards = async (id) => {
    const result = await axiosWithToken(`${serverURL}/coupon/${id}/rewards/`, 'get', {});
    return result;
}